export default "__VITE_ASSET__b970b24e__"